export const durations = [
    { value: 'monthly', text: 'Monthly' },
    { value: 'quarterly', text: 'Quarterly' },
    { value: 'six-months', text: '6 Months' },
    { value: 'yearly', text: 'Yearly' },
    { value: 'bi-yearly', text: 'Bi Yearly' },
    // { value: 'three-years', text: '3 Years' },
    { value: 'days', text: 'Days' },
];

export const planTypes = [
    { value: 'tier', text: 'Premium' },
    { value: 'product', text: 'Product' },
];

export const SCHEDULE_STATES = {
    downgrade: 'downgrade',
    update: 'update',
};
